document.addEventListener('DOMContentLoaded', function() {
  const loginSubmit = document.getElementById('input-login-submit');
  const phoneInput = document.getElementById('input-login-phone');
  const inputOTPContainer = document.getElementById('display-otp-input');
  const inputOTPField = document.getElementById('input-login-otp');
  const inputFieldContainer = document.getElementById('number-field-container');
  const submitOTP = document.getElementById('submit-login-otp');
  const resetMobile = document.querySelector('#resetMobile');
  const signInTimer = document.getElementById('signInTimer');
  const signInResend = document.getElementById('signInResend');
  const signInResendTimer = document.getElementById('signInResendTimer');

  let otpTimer;

  // Send OTP
  if(loginSubmit) {
    loginSubmit.addEventListener('click', function(event) {
      event.preventDefault();

      const phone = phoneInput.value.trim();
      clearError('#customerLoginPhoneError');

      // Validate Phone Number
      if(!phone) {
        displayError('#customerLoginPhoneError', 'Mobile Number is Required');
        return false;
      }else if(!/^[6789]\d{9}$/.test(phone)) {
        displayError('#customerLoginPhoneError', 'Enter a Valid Mobile Number');
        return;
      }

      // Make API Call To Send OTP
      fetch('https://hul-services.enscommerce.in/optimum-nutrition/services/loginservice/login/sendotp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          mobileNumber: phone
        })
      })
      .then(response => response.json())
      .then(data => {
        if(data && data.success) {
          inputOTPContainer.style.display = 'block';
          submitOTP.style.display = 'block';
          loginSubmit.style.display = 'none';
          inputFieldContainer.style.display = 'none';
          resetMobile.style.display = 'block';

          // Start OTP resend timer
          startResendTimer();
        }else {
          displayError('#customerLoginPhoneError', data.message);
        }
      })
      .catch(error => {
        console.error('Error Sending OTP:', error);
      });
    });
  }

  // Verify OTP
  if(submitOTP) {
    submitOTP.addEventListener('click', function(event) {
      event.preventDefault();

      const otp = inputOTPField.value.trim();
      clearError('#customerLoginOTPError'); // Clear Previous Error Messages

      // Validate OTP
      if(!otp) {
        displayError('#customerLoginOTPError', 'OTP is Required');
        return false;
      }else if(!/^\d{6}$/.test(otp)) {
        displayError('#customerLoginOTPError', 'Enter a Valid 6-Digit OTP');
        return;
      }

      const phone = phoneInput.value.trim();
        // Check for reward page has url checkout_url
      const params = new URLSearchParams(window.location.search);
      const checkoutUrl = params.get("checkout_url");

      // Make API Call To Verify OTP
      fetch('https://hul-services.enscommerce.in/optimum-nutrition/services/loginservice/login/verifyotp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          mobileNumber: phone,
          otp: otp
        })
      })
      .then(response => response.json())
      .then(data => {
        if(data && data.success) {
          window.location.href = data.url;
          if(checkoutUrl){
              sessionStorage.setItem('redirect_to_reward', true );
            }
        }else {
          displayError('#customerLoginOTPError', 'Invalid OTP');
        }
      })
      .catch(error => {
        console.error('Error Verifying OTP:', error);
      });
    });
  }

  // Timer Function
  function startResendTimer() {
    // let timeLeft = 180;
    let timeLeft = 30;
    signInTimer.style.display = 'block';
    signInResend.style.display = 'none';
    
    // Function To Update Timer
    otpTimer = setInterval(function() {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      signInResendTimer.textContent = `Resend OTP in ${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      timeLeft--;

      if(timeLeft < 0) {
        clearInterval(otpTimer);
        signInTimer.style.display = 'none';
        signInResend.style.display = 'block';
      }
    }, 1000);
  }

  // Resend OTP
  if(signInResend) {
    signInResend.querySelector('a').addEventListener('click', function(event) {
      event.preventDefault();

      // Send OTP again
      const phone = phoneInput.value.trim();
      
      // Make API Call To Send OTP
      fetch('https://hul-services.enscommerce.in/optimum-nutrition/services/loginservice/login/sendotp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          mobileNumber: phone
        })
      })
      .then(response => response.json())
      .then(data => {
        if(data && data.success) {
          // Reset Timer
          startResendTimer();
        }else {
          displayError('#customerLoginPhoneError', data.message);
        }
      })
      .catch(error => {
        console.error('Error Sending OTP:', error);
      });
    });
  }
});

// Display Error Message
function displayError(fieldId, message) {
  const errorElement = document.querySelector(fieldId);
  
  if(errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = 'block';
  }
}

// Clear Error Message
function clearError(fieldId) {
  const errorElement = document.querySelector(fieldId);
  
  if(errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  }
}